import moment from 'moment';
import { CaptainUserInfo } from './users';
import {
  DateTimeFormateLeftToRight,
  DateTimeFormatHoursMinutesOnly,
} from '../../config/constants';

export interface Shift {
  id: number;
  finished: boolean;
  start_datetime: string;
  end_datetime: string;
  city_id: number;
  registered_carriers: Registeredcarrier[];
  desired_carriers: number;
  shipments_count: number;
  is_recieving_new_orders: boolean;
  is_active: boolean;
}

export interface ShiftCreate {
  start_datetime: string;
  end_datetime: string;
  desired_carriers: number;
  is_recieving_new_orders?: boolean;
  id?: number;
}

export interface Registeredcarrier {
  id: number;
  is_disabled: boolean;
  delivery_user: CaptainUserInfo;
  carrier_type: number;
  city_id: number;
}

export function shiftTypeFormatStartAndEndDateTime(shift: Shift) {
  return (
    moment(shift.start_datetime).format(DateTimeFormatHoursMinutesOnly) +
    '-' +
    moment(shift.end_datetime).format(DateTimeFormateLeftToRight)
  );
}
